// NPM
import React from 'react';
import _ from 'lodash';
import { colord } from 'colord';

// State
import { useSelector } from 'react-redux';

// Components
import RoundedRect from 'components/shared/RoundedRect';

// Constants
import constants from './constants';

export default function SeatDistributionGroup(props) {
  const { seatDistributionGroup, previousGroups } = props;

  // State
  const parties = useSelector(state => state.parties.value);
  const campaignConfig = useSelector(state => state.campaignConfig.value);
  const responsiveView = useSelector(state => state.responsiveView.value);

  const { seatsPerRow } = _.get(campaignConfig, "sections.SeatDistribution", {});

  let offsetTop = 0;
  offsetTop += previousGroups.length * constants.groupMarginTop;
  offsetTop += _.sumBy(previousGroups, pg => pg.length) * constants.seatLength;
  offsetTop += _.sumBy(previousGroups, pg => pg.length) * constants.seatGap;

  return (
    seatDistributionGroup.map((row, rowIndex) => {
      let rowOffsetTop = 0;
      rowOffsetTop += rowIndex * constants.seatLength;
      rowOffsetTop += rowIndex * constants.seatGap;

      return row.map((seat, seatIndex) => {
        let party = parties.find(p => p.id === seat.party);
        let seatOffsetLeft = 0;
        seatOffsetLeft += seatIndex * constants.seatLength;
        seatOffsetLeft += seatIndex * constants.seatGap;

        return (
          <g key={ `SeatShareGraphRow-${ rowIndex }-seat-${ seatIndex }` }>
            <RoundedRect
              x={ seatOffsetLeft }
              y={ offsetTop + rowOffsetTop }
              width={ constants.seatLength }
              height={ constants.seatLength }
              radius={ constants.seatRounding }
              fill={ colord(party.color).toHex() }
              stroke={ party.color }
              tlRounded
              trRounded
              brRounded
              blRounded
            />
          </g>
        )    
      })
    })
    
  )
  
}